import "./AcceptRegistrationInvite.css";
import { useState, Fragment } from "react";
import { ReactComponent as ArrowLeftIcon } from "../../icons/arrow-left.svg";
import { ReactComponent as CheckIcon } from "../../icons/check.svg";
import { useHistory, useParams } from "react-router-dom";
import { useQuery, useMutation } from "@apollo/client";
import {
  EVENT,
  EVENT_REGISTRATION_INVITE,
  ACCEPT_REGISTRATION_INVITE,
} from "../../api/event";
import { LOGIN, SIGNUP } from "../../api/auth";
import { USER_ORGANIZATIONS } from "../../api/user";
import Spinner from "../../components/Spinner";
import Loader from "../../components/Loader";
import moment from "moment";
import { ReactComponent as CalendarIcon } from "../../icons/calendar.svg";
import { ReactComponent as PinIcon } from "../../icons/pin.svg";
import { ReactComponent as RupeeIcon } from "../../icons/rupee.svg";
import makeFileUrl from "../../utils/makeFileUrl";
import Barcode from "react-jsbarcode";
import { usePageTracking } from "../../utils/usePageTracking";
import captureException from "../../utils/captureException";
import { USER_PROFILE } from "../../api/user";
import { useAppState } from "../../utils/appState";
import { ReactComponent as LockIcon } from "../../icons/lock.svg";
import { ReactComponent as EyeIcon } from "../../icons/eye.svg";
import { ReactComponent as MailIcon } from "../../icons/mail.svg";
import DebouncedButton from "../../components/Button/DebouncedButton";
import getNames from "../../utils/getNames";

function ConfirmAndRegister({ invite, userProfile }) {
  const history = useHistory();
  const [errorMessage, setErrorMessage] = useState("");
  const [mutate, { loading: acceptRegistrationInviteLoading }] = useMutation(
    ACCEPT_REGISTRATION_INVITE,
    {
      update: (cache, { data: { acceptRegistrationInvite } }) => {
        // console.log(login);
        if (acceptRegistrationInvite?.id) {
          // setError(true);
          history.push("/app/register/" + invite.event.id);
        }
      },
      onError: (error) => {
        captureException({
          error,
          info: {
            type: "mutation",
            component: "AcceptRegistrationInvite",
            mutation: "ACCEPT_REGISTRATION_INVITE",
          },
        });
        console.log(error);
        setErrorMessage(error.message);
      },
    }
  );
  // Step 5

  return (
    <div className="mobile-auth-form">
      <div className="mobile-auth-form__header">Confirm your registration</div>
      <div style={{ marginBottom: "32px" }}>
        <div className="">
          <div className="mobile-auth-form__form__group">
            <div className="mobile-auth-form__form__group__key">Event</div>
            <div className="mobile-auth-form__form__group__value">
              {invite.event.name}
            </div>
          </div>

          <div className="mobile-auth-form__form__group">
            <div className="mobile-auth-form__form__group__key">Player</div>
            <div className="mobile-auth-form__form__group__value">
              {userProfile.name}
            </div>
          </div>

          {invite.organization && (
            <div className="mobile-auth-form__form__group">
              <div className="mobile-auth-form__form__group__key">Team</div>
              <div className="mobile-auth-form__form__group__value">
                {invite.organization.name}
              </div>
            </div>
          )}
        </div>
      </div>
      <DebouncedButton
        className={"mobile-auth-form__form__submit "}
        loading={acceptRegistrationInviteLoading}
        disableDefaultStyles={true}
        onClick={() => {
          mutate({
            variables: {
              inviteId: invite.id,
            },
          });
        }}
      >
        {acceptRegistrationInviteLoading ? (
          <Loader theme="small" />
        ) : (
          "Confirm and Register"
        )}
      </DebouncedButton>

      {errorMessage && (
        <div className="mobile-auth-form__form__error">{errorMessage}</div>
      )}
    </div>
  );
}

function LoginOrSignup({ invite, refetchUserProfile, loadingUserProfile }) {
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [invalidPassword, setInvalidPassword] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [, setAppState] = useAppState();

  const [login, { loading: loginLoading }] = useMutation(LOGIN, {
    update: (cache, { data: { login } }) => {
      // console.log(login);
      if (!login.token || !login.expiresAt) {
        // setError(true);
        return;
      }

      localStorage.setItem("sp_auth_token", login.token);
      localStorage.setItem("sp_expires_at", login.expiresAt);
      localStorage.setItem("sp_name", login.name);
      setAppState({ isLoggedIn: true });

      refetchUserProfile();

      //   history.push("/app");
    },
    onError: (error) => {
      captureException({
        error,
        info: {
          type: "mutation",
          component: "AcceptRegistrationInvite",
          mutation: "LOGIN",
        },
      });
      console.log(error);
      setErrorMessage(error.message);
    },
  });

  const [signup, { loading: signupLoading }] = useMutation(SIGNUP, {
    onError: (e) => {
      console.log(e.message);
      setErrorMessage(e.message);
    },
    update: (cache, { data: { signup } }) => {
      // console.log(signup);
      if (!signup.token || !signup.expiresAt) {
        // setError(true);
        return;
      }

      localStorage.setItem("sp_auth_token", signup.token);
      localStorage.setItem("sp_expires_at", signup.expiresAt);
      localStorage.setItem("sp_name", signup.name);
      setAppState({ isLoggedIn: true });

      refetchUserProfile();
    },
    onError: (error) => {
      captureException({
        error,
        info: {
          type: "mutation",
          component: "AcceptRegistrationInvite",
          mutation: "SIGNUP",
        },
      });
      console.log(error);
      setErrorMessage(error.message);
    },
  });

  // Step 4
  return (
    <div className="mobile-auth-form">
      {invite.isExistingUserInvite ? (
        <div className="mobile-auth-form__header">
          Login to your existing sports paddock account
        </div>
      ) : (
        <div className="mobile-auth-form__header">
          Enter password for your new sports paddock account
        </div>
      )}

      <div className="mobile-auth-form__form__group">
        <div className="mobile-auth-form__form__group__label">
          Email <span style={{ color: "var(--red-main)" }}>*</span>
        </div>

        <div
          className={"mobile-auth-form__form__group__field "}
          style={{ background: "var(--light-2)" }}
        >
          <div className="mobile-auth-form__form__group__field__icon">
            <MailIcon style={{ fill: "var(--light-3)", height: 14 }} />
          </div>

          <input
            type="email"
            className="mobile-auth-form__form__group__field__input"
            value={invite.email}
            onChange={(e) => {
              // if (errorMessage) {
              //   setErrorMessage("");
              // }
              // setEmail(e.target.value);
            }}
            disabled
            style={{ color: "var(--dark-4)" }}
          />
        </div>
      </div>

      <div
        className="mobile-auth-form__form__group"
        style={{ marginBottom: "32px" }}
      >
        <div className="mobile-auth-form__form__group__label">
          Password <span style={{ color: "var(--red-main)" }}>*</span>
        </div>

        <div
          className={
            "mobile-auth-form__form__group__field " +
            (invalidPassword ? "error" : "")
          }
        >
          <div className="mobile-auth-form__form__group__field__icon">
            <LockIcon style={{ fill: "var(--light-3)", height: 14 }} />
          </div>

          <input
            type={showPassword ? "text" : "password"}
            id="current-password"
            value={password}
            className="mobile-auth-form__form__group__field__input"
            autoComplete="current-password"
            onChange={(e) => {
              if (errorMessage) {
                setErrorMessage("");
              }
              setPassword(e.target.value);
            }}
            onFocus={() => {
              setInvalidPassword(false);
            }}
          />

          <div
            className="mobile-auth-form__form__group__field__icon"
            onClick={() => {
              setShowPassword((prev) => !prev);
            }}
          >
            <EyeIcon
              style={{
                fill: showPassword ? "var(--blue-main)" : "var(--light-4)",
                height: 14,
              }}
            />
          </div>
        </div>
      </div>

      {errorMessage && (
        <div className="mobile-auth-form__form__error">{errorMessage}</div>
      )}

      <DebouncedButton
        className={"mobile-auth-form__form__submit "}
        loading={loginLoading || signupLoading || loadingUserProfile}
        disableDefaultStyles={true}
        onClick={() => {
          if (invite.isExistingUserInvite) {
            login({
              variables: {
                email: invite.email,
                password,
              },
            });
          } else {
            signup({
              variables: {
                name: invite.name,
                firstname: getNames(invite.name).firstname,
                lastname: getNames(invite.name).lastname,
                handle: invite.handle,
                email: invite.email,
                password,
              },
            });
          }
        }}
      >
        {loginLoading || signupLoading ? <Loader theme="small" /> : "Next"}
      </DebouncedButton>

      {/* <div className="mobile-auth-form__footer">
        {invite.isExistingUserInvite && (
          <div className="mobile-auth-form__footer__statement">
            Forgot your password?{" "}
            <div
              className="mobile-auth-form__footer__statement__link"
              onClick={() => {
                // Send password reset email
              }}
            >
              Click here
            </div>
          </div>
        )}
      </div> */}
    </div>
  );
}

export default function AcceptRegistrationInvite() {
  // Step 1
  usePageTracking({ title: "Accept Registration Invite" });
  const { id } = useParams();

  const {
    loading: loadingUserProfile,
    data: dataUserProfile,
    error: errorUserProfile,
    refetch: refetchUserProfile,
  } = useQuery(USER_PROFILE, { notifyOnNetworkStatusChange: true });
  const { loading, error, data } = useQuery(EVENT_REGISTRATION_INVITE, {
    variables: { id },
  });

  if (error || errorUserProfile) {
    if (errorUserProfile) {
      captureException({
        error: errorUserProfile,
        info: {
          type: "query",
          component: "AcceptRegistrationInvite",
          query: "USER_PROFILE",
        },
      });
    } else {
      captureException({
        error,
        info: {
          type: "query",
          component: "AcceptRegistrationInvite",
          query: "EVENT_REGISTRATION_INVITE",
        },
      });
    }

    return <div>Error</div>;
  }

  if (loading || loadingUserProfile || !data || !dataUserProfile) {
    return (
      <div
        style={{
          height: "400px",
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Spinner />
      </div>
    );
  }

  const userProfile = dataUserProfile?.userProfile;
  const invite = data?.eventRegistrationInvite;

  if (!invite?.id) {
    return <div>Invalid registration invite</div>;
  }

  //   if (userProfile) {
  //     return <ConfirmAndRegister invite={invite} userProfile={userProfile} />;
  //   } else {

  //     return (

  //       <LoginOrSignup invite={invite} refetchUserProfile={refetchUserProfile} />
  //     );
  //   }

  return (
    <div className="mobile-auth-page__wrapper">
      <div className="mobile-auth-page">
        <div className="mobile-auth-page__logo">
          <img src="/logo.svg" alt="" />
        </div>

        {userProfile?.id ? (
          <ConfirmAndRegister invite={invite} userProfile={userProfile} />
        ) : (
          <LoginOrSignup
            invite={invite}
            refetchUserProfile={refetchUserProfile}
            loadingUserProfile={loadingUserProfile}
          />
        )}

        <div className="mobile-auth-page__graphic">
          <img src="/circle-bg.svg" alt="" />
        </div>

        <div className="mobile-auth-page__logo-bottom">
          <img src="/logo-white.svg" alt="" />
        </div>
      </div>
    </div>
  );
}
